<h1 mat-dialog-title>Assign A Medication</h1>
<p>{{ prompt }}</p>
@if (env !== 'production') {
<mat-radio-group
  [formControl]="environment"
  class="d-flex mm-gap-10"
  aria-label="Select an option"
>
  @for (option of options; track option) {
  <mat-radio-button [value]="option">
    {{ option.label }}
  </mat-radio-button>
  }
</mat-radio-group>
}
<mat-divider style="margin-top: 1rem"></mat-divider>
<div mat-dialog-content>
  <ng-container *ngComponentOutlet="component"></ng-container>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="submit()" class="mm-bg-accent mm-ml-3 mm-text-white">
    Confirm
  </button>
</mat-dialog-actions>

@if (loading) {
<div class="loading-overlay">
  <mat-spinner diameter="45"></mat-spinner>
</div>
}
